<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search mr-2'></i>Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="6" md="6" lg="4" xl="3" class="mb-2">
                  <label class="mr-sm-2" for="sStartTime">Registered From</label>
                  <b-input type="date" placeholder="" v-model.trim="form.startDate" ></b-input>
                </b-col>
                <b-col sm="6" md="6" lg="4" xl="3" class="mb-2">
                  <label class="mr-sm-2" for="sEndTime">To</label>
                  <b-input type="date" placeholder="" v-model.trim="form.endDate" ></b-input>
                </b-col>
                <b-col sm="6" md="6" lg="4" xl="3" class="mb-2">
                  <label class="mr-sm-2" for="sUsername">Username</label>
                  <b-input placeholder="Username" v-model.trim="form.username" ></b-input>
                </b-col>
                <b-col sm="6" md="6" lg="4" xl="3" class="mb-2">
                  <label class="mr-sm-2" for="status">Status</label>
                  <p-select v-model="form.status" name="status" :options="statusOptions" :handler="$v" :formData="form"/>
                </b-col>
                <b-col sm="6" md="6" lg="4" xl="3" class="mb-2">
                  <label class="mr-sm-2" for="sEndTime">&nbsp;</label><br>
                  <b-button id="sBtn" variant="primary" :disabled="fetching" @click="getMemberList"><i class="fa fa-search mr-2"></i>Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
     <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left">Member List</h3>
          </b-card-header>
          <b-card-body>
            <b-table responsive="sm" :items="items" :fields="fields" :busy="fetching" >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(index)="data">
                {{ data.index+1 + ((currentPage-1)*perPage) }}
              </template>
              <template v-slot:cell(Status)="data">
                <b-badge v-if="data.item.Status === 0" variant="success" class="mr-sm-2">Enabled</b-badge>
                <b-badge v-else-if="data.item.Status === 1" variant="danger" class="mr-sm-2">Disabled</b-badge>
                <b-badge v-else-if="data.item.Status === 2" variant="warning" class="mr-sm-2">Frozen</b-badge>
                <b-badge v-else-if="data.item.Status === 4" variant="warning" class="mr-sm-2">Invalid</b-badge>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount()" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { PSelect } from '../../../components'

export default {
  name: 'MemberListTable',
  components: {
    PSelect
  },
  data () {
    return {
      fetching: false,
      currentPage: 1,
      perPage: 20,
      rowCount: 0,
      agentCode: '',
      form: {
        startDate: '',
        endDate: '',
        username: '',
        status: 'null'
      },
      statusOptions: [
        { Name: 'Enabled', Value: 0 },
        { Name: 'Disabled', Value: 1 },
        { Name: 'Frozen', Value: 2 },
        { Name: 'Invalid', Value: 4 }
      ],
      items: [],
      fields: [
        { key: 'index', label: 'S.No' },
        { key: 'Username', label: 'Username' },
        { key: 'AddTime', label: 'Register Time' },
        { key: 'AddIP', label: 'Register Ip' },
        { key: 'Status', label: 'Status' }
      ]
    }
  },
  validations: {
    form: {
      status: {}
    }
  },
  watch: {
    currentPage: function () {
      this.getMemberList()
    }
  },
  methods: {
    getRowCount () {
      return this.rowCount
    },
    async getMemberList () {
      try {
        this.fetching = true
        if (window.sessionStorage.getItem('client')) {
          const user = JSON.parse(window.sessionStorage.getItem('client'))
          this.agentCode = user.code
        }
        const queryParams = {
          username: this.form.username,
          startDate: this.form.startDate,
          endDate: this.form.endDate,
          status: this.form.status,
          page: this.currentPage,
          size: this.perPage,
          agentCode: this.agentCode
        }
        let queryStr = `?username=${queryParams.username}&status=${queryParams.status}&startDate=${queryParams.startDate}&endDate=${queryParams.endDate}&size=${queryParams.size}&page=${queryParams.page}&agentCode=${queryParams.agentCode}`
        const { data: { players, totalCount } } = await this.$http.get(`${this.API_ENDPOINT}/api/v1/agent/player/getList` + queryStr, { headers: { 'Content-Type': 'application/json' } })
        this.items = players
        this.rowCount = totalCount
      } catch (err) {
        console.log('fetching member list error: ', err)
      } finally {
        this.fetching = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/MemberList/MemberListTable.vue